// helpers/auth.guard.ts
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AzureAuthService } from '../services/azure-auth.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private azureAuthService: AzureAuthService,
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    console.log('AuthGuard: Verificando acceso a:', state.url);

    // 🔧 MODO DESARROLLO: Bypasear autenticación
    if (environment.useMockAuth) {
      console.log('🔧 AuthGuard: MODO MOCK - Acceso permitido automáticamente');
      return true;
    }

    try {
      // Verificar autenticación con Azure AD
      if (this.azureAuthService.isFullyAuthenticated()) {
        console.log('AuthGuard: Usuario autenticado con Azure AD');
        return true;
      }

      // No autenticado - redirigir al login
      console.log('AuthGuard: No autenticado, redirigiendo a login');
      this.router.navigate(['/login']);
      return false;
    } catch (error) {
      console.error('AuthGuard: Error verificando autenticación:', error);
      this.router.navigate(['/login']);
      return false;
    }
  }
}

// helpers/no-auth.guard.ts
@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private azureAuthService: AzureAuthService,
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    console.log('NoAuthGuard: Verificando acceso a login');

    // 🔧 MODO DESARROLLO: Redirigir directamente a la app
    if (environment.useMockAuth) {
      console.log('🔧 NoAuthGuard: MODO MOCK - Redirigiendo a /app/chat');
      return this.router.createUrlTree(['/app/chat']);
    }

    try {
      // Verificar si ya está autenticado con Azure AD
      if (this.azureAuthService.isFullyAuthenticated()) {
        console.log(
          'NoAuthGuard: Usuario ya autenticado, redirigiendo a /app/chat',
        );
        return this.router.createUrlTree(['/app/chat']);
      }

      // No autenticado - permitir acceso al login
      console.log('NoAuthGuard: Permitiendo acceso a login');
      return true;
    } catch (error) {
      console.error('NoAuthGuard: Error verificando autenticación:', error);
      return true; // En caso de error, permitir acceso al login
    }
  }
}
